import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import ScaleLoader from "react-spinners/ScaleLoader"
import shortId from "shortid"
import { ConsolidationRequest, EconomyconsolMasterLabelRequest } from "../../api/consolidation.api"
import { useAppDispatch, useAppSelector } from "../../app/hooks"
import AE from "../../assets/country/AE.svg"
import IQ from "../../assets/country/IQ.svg"
import SA from "../../assets/country/SA.svg"
import { RootState } from "../../store"
import { setConsolBox } from "../../store/consolidation.store"
import {
    generateMasterLabel,
    loadCountriesList,
    loadEconomyConsols,
    resetSuccess,
    setSelectedCountry
} from "../../store/economyconsol.store"
import ConsolidateModal from "../Consolidations/ConsolidateModal"
import PostConsolidationModal from "../Consolidations/PostConsolidationModal"
import Header from "../Layout/Header"
import EconomyConsolTable from "./EconomyConsolTable"

const EconomyConsols = () => {
    const dispatch = useAppDispatch()
    const { t } = useTranslation()
    const { userInfo } = useAppSelector((state: RootState) => state.auth)
    const { economyconsols, loading, error, selectedCountry, countriesList, label, success } = useAppSelector(
        (state: RootState) => state.economyconsols
    )
    const { consolBox } = useAppSelector((state: RootState) => state.consolidations)

    const { selectedWarehouse } = useAppSelector((state: RootState) => state.warehouses)
    const [selectedRow, setSelectedRow] = useState({} as Record<string, any>)
    const [printLoading, setPrintLoading] = useState(false)
    const [errors, setErrors] = useState({} as Record<string, any>)

    const [show, setShow] = useState("")
    const countryChange = (country: string) => {
        dispatch(setSelectedCountry(country))
    }

    const defaultWarehouse = userInfo?.ParcelHubUserWarehouse?.find(
        (uw: Record<string, any>) => uw?.is_default
    )?.warehouse_id

    useEffect(() => {
        dispatch(loadCountriesList())
    }, [])

    useEffect(() => {
        dispatch(loadEconomyConsols({ country: selectedCountry }))
    }, [selectedCountry])

    const consolidateBox = (consolidationData: ConsolidationRequest) => {
        dispatch(
            setConsolBox({
                ...consolBox,
                Children: Object.values(consolidationData?.parcels_in_boxes).map(
                    (box: Record<string, any>[], index: number) => ({
                        parcels: [...box],
                        uuid: shortId.generate(),
                        box_ui_id: `Master Box ${index + 1}`
                    })
                )
            })
        )

        setShow("addWeightAndDims")
    }

    const handleSubmit = async (economyconsolMasterLabelData: EconomyconsolMasterLabelRequest) => {
        await dispatch(generateMasterLabel(economyconsolMasterLabelData))
    }

    const afterReload = async () => {
        if (success) {
            setShow("")
            setConsolBox({})
            dispatch(loadCountriesList())
            dispatch(loadEconomyConsols({ country: selectedCountry }))
            const labelLink = document.createElement("a") as HTMLAnchorElement
            labelLink.className = "d-none"
            labelLink.href = label || ""
            labelLink.target = "_blank"
            labelLink.click()
        }
        dispatch(resetSuccess())
    }

    useEffect(() => {
        afterReload()
    }, [success])

    const returnCountryFlag = (country: string): string => {
        switch (country) {
            case "SA":
                return SA
            case "AE":
                return AE
            case "IQ":
                return IQ
            default:
                return ""
        }
    }

    return (
        <>
            <div className="economyconsol-container">
                <Header
                    title={"Economy Consol"}
                    subtitle={"Shopini Economy"}
                    data={economyconsols}
                    name="EconomyConsol"
                    buttonId=".economyConsolExportButton">
                    {/* <div className="mx-2">
							<DateRangePickerCustom setStartDate={setStartDate} setEndDate={setEndDate}  startDate={startDate} endDate={endDate} />
						</div> */}
                </Header>

                <div className="row justify-content-start mt-5 px-2">
                    {countriesList.length > 0 &&
                        countriesList?.map((country: any) => (
                            <div
                                className={
                                    selectedCountry === country?.country
                                        ? "col-lg-2 col-md-6 shipping_dispatch company_selected"
                                        : "col-lg-2 col-md-6 shipping_dispatch"
                                }>
                                <div className="card p-4" onClick={() => countryChange(country?.country)}>
                                    <img
                                        src={returnCountryFlag(country?.country)}
                                        className="mx-auto img-fluid w-75 mb-3"
                                    />
                                    <span className="text-center mb-2">{country?.country_name}</span>
                                    <small className="text-center px-2">
                                        {t("Shipments")}: &nbsp;
                                        <strong className="text-primary">{country?.shipment_count}</strong>
                                    </small>
                                </div>
                            </div>
                        ))}
                </div>
                {loading || !userInfo?.accessToken ? (
                    <div className="loader row justify-content-center">
                        <ScaleLoader color="#15397F" width={4} height={40} />
                    </div>
                ) : (
                    <div className="row  d-flex">
                        <EconomyConsolTable
                            economyconsols={economyconsols}
                            setSelectedRow={setSelectedRow}
                            setShow={setShow}
                        />
                        <ConsolidateModal
                            show={show}
                            setShow={setShow}
                            consolidateBox={consolidateBox}
                            country={selectedCountry}
                        />
                        <PostConsolidationModal
                            show={show}
                            setShow={setShow}
                            handleSubmit={handleSubmit}
                            errors={errors}
                            setErrors={setErrors}
                            warehouse={selectedWarehouse || defaultWarehouse}
                            country={selectedCountry}
                        />
                    </div>
                )}
            </div>
        </>
    )
}

export default EconomyConsols
